// @ts-nocheck
import React, { lazy } from 'react';
import { Dialog, DialogSuspense } from '@/components';
import withDialogRedux from '@/components/DialogReduxConnect';
import { compose } from '@/utils';
import { CatalogItemSelectionProvider } from './CatalogItemSelectionProvider';
import CatalogItemSelectionContent from './CatalogItemSelectionContent';

function CatalogItemSelectionDialog({
  dialogName,
  payload = { provider: 'esp', onConfirm: null, onCancel: null },
  isOpen,
}) {
  return (
    <Dialog
      name={dialogName}
      title=""
      className="dialog--catalog-item-selection"
      isOpen={isOpen}
      autoFocus
      canEscapeKeyClose
      style={{ width: '90vw', maxWidth: 'none', height: '90vh', maxHeight: '90vh', margin: 0, padding: 0 }}
    >
      <DialogSuspense>
        <CatalogItemSelectionProvider
          initialProvider={payload.provider || 'esp'}
          orderId={null}
          estimateId={null}
        >
          <CatalogItemSelectionContent />
        </CatalogItemSelectionProvider>
      </DialogSuspense>
    </Dialog>
  );
}

export default compose(withDialogRedux())(CatalogItemSelectionDialog);
